import { EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

const MonitorCard = ({
  title,
  date = '',
  showFilterBtn = true,
  hasData = false,
  children,
  color = 'blue'
}) => {
  const { t } = useTranslation()
  // Color mapping for different variants
  const colorClasses = {
    blue: {
      text: 'text-blue-600',
      border: 'border-blue-200'
    },
    green: {
      text: 'text-green-600',
      border: 'border-green-200'
    },
    red: {
      text: 'text-red-600',
      border: 'border-red-200'
    },
    purple: {
      text: 'text-purple-600',
      border: 'border-purple-200'
    },
    yellow: {
      text: 'text-yellow-600',
      border: 'border-yellow-200'
    },
    indigo: {
      text: 'text-indigo-600',
      border: 'border-indigo-200'
    }
  }

  const currentColor = colorClasses[color] || colorClasses.blue
  return (
    <div className='h-full flex flex-col'>
      <div className={`rounded shadow border ${currentColor.border} bg-white p-4 flex-1 flex flex-col`}>
        <div className='flex justify-between items-start mb-2'>
          <div>
            <h2 className={`text-lg font-semibold ${currentColor.text}`}>{title}</h2>
            <p className='text-sm text-gray-600'>
              {date && t('dashboard.lastPickingDay', { date })}{' '}
              {showFilterBtn && (
                <button className={`${currentColor.text} font-medium ml-2`}>{t('dashboard.changeFilters')}</button>
              )}
            </p>
          </div>
          <EllipsisVerticalIcon className='w-5 h-5 text-gray-400' />
        </div>

        <div className={hasData ? 'text-gray-500' : 'flex justify-center items-center h-32 text-gray-500'}>
          {hasData ? children : t('dashboard.noDataDisplay')}
        </div>
      </div>
    </div>
  )
}

export default MonitorCard
